module.exports = __webpack_public_path__ + "static/media/HCMM032.f7be3661.jpg";